import { render, staticRenderFns } from "./Bloco.vue?vue&type=template&id=b0814e94&"
import script from "./Bloco.vue?vue&type=script&lang=js&"
export * from "./Bloco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports